import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { MEDIA_SECTIONS, mediaPath } from '../helpers';
import styles from '../News.module.css';

const tileClass = `${styles.tile} flex flex-col gap-3 text-dark dark:text-white`;

const TileImage = ({ src }) => (
  <div className={`${styles.frame} ${styles.ratio4x3}`}>
    {src && <img src={src} alt="" loading="lazy" className="w-full h-full object-cover" />}
  </div>
);

TileImage.propTypes = { src: PropTypes.string };
TileImage.defaultProps = { src: null };

const MultimediaTiles = ({ thumbnails, mediaKitUrl }) => (
  <section aria-labelledby="news-multimedia" className="mt-16">
    <h2 id="news-multimedia" className={styles.sectionTitle}>Multimedia</h2>
    <div className={styles.tileGrid}>
      {MEDIA_SECTIONS.map(section => (
        <Link key={section.slug} to={mediaPath(section.slug)} className={tileClass} data-part="news-tile">
          <TileImage src={thumbnails[section.thumbnailKey]} />
          <span className={`${styles.tileLabel} font-montserratBold text-lg`}>{section.title}</span>
        </Link>
      ))}
      {mediaKitUrl && (
        <a href={mediaKitUrl} target="_blank" rel="noopener noreferrer" className={tileClass} data-part="news-tile">
          <TileImage src={thumbnails.mediaKit} />
          <span className={`${styles.tileLabel} font-montserratBold text-lg`}>Media Kit</span>
        </a>
      )}
    </div>
  </section>
);

MultimediaTiles.propTypes = {
  thumbnails: PropTypes.shape({
    images: PropTypes.string,
    news: PropTypes.string,
    videos: PropTypes.string,
    mediaKit: PropTypes.string,
  }),
  mediaKitUrl: PropTypes.string,
};

MultimediaTiles.defaultProps = {
  thumbnails: {},
  mediaKitUrl: null,
};

export default MultimediaTiles;
